import {Component, Inject, Input, OnInit, OnDestroy, DoCheck, ElementRef, ViewChild, HostListener} from '@angular/core';
import { Filters } from 'src/app/global/filter-model';
import { FiltersService } from 'src/app/core/services/filters.service';
import { FilterOptionService } from 'src/app/features/filter-selection/services/filter-option.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ContractModel } from 'src/app/global/contract-filter-model';
import { DistributorFilterModel, DivDataView, FilterOption } from 'src/app/global/filter-options-types';
import { Subscription } from 'rxjs/internal/Subscription';
import { PresentationService } from '../../services/presentation.service';
import { AlertService } from '../../services/alert.service';
import { Alert } from 'src/app/global/types';
import { AuthenticationService } from '../../services/authentication.service';
import { AuthorizationService } from '../../services/authorization.service';
import { Permission, Role } from 'src/app/global/policy-types';
import { ServiceInsightsService } from 'src/app/features/service-insights/services/service-insights-service.service';
import { BrandingService } from '../../services/branding.service';
import { FEATURE_FLAGS, FeatureFlags } from 'src/app/config/AppInitializer.factory';
import { UserService } from '../../services/user.service';
import { CurrencyUomService, UomOption } from '../../services/currency-uom.service';
import { MixpanelService } from '../../services/mixpanel.service';
import { CurrencyDefinition } from '../../services/ebr-api-client/ebr-api-client.g';
import { filter } from 'rxjs';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy, DoCheck {
  filters: ContractModel | undefined;
  filtersSubscription: Subscription | undefined;
  rolesSubscription: Subscription | undefined;
  pptDownloadSubscription: Subscription | undefined;
  currencySubscription: Subscription | undefined;
  uomSubscription: Subscription | undefined;
  currencyOptionsSubscription: Subscription | undefined;
  currencyLoadingSubscription: Subscription | undefined;

  displaySecondLevel: boolean = true;

  @Input() hidePresentationDownload: boolean = true;
  @Input() filterRequest: ContractModel | undefined;

  downloadPresentationStatus: string = 'Download Presentation';
  bannerClass: string = 'banner-prod';
  topLevelText="H5s:";
  secondLevelText="H7s:";
  HeaderText="H5s/H7s";
  pageName: string = '';
  filterOptions: FilterOption[] | undefined;
  selectedDataView: string = '';

  //PPT 2.0
  name: string = 'Download PPT 2.0';
  @Input() presentationType: string = '';

  disablePresentationDownload: boolean = false;

  //Program Hub Flag
  isLocked : boolean = true;

  // Benchmark dialog properties
  showBenchmark: boolean = false;
  benchmarkTitle: string = '';
  selectedBenchmarkOption: string = '';

  selectedCurrency: string = 'USD';
  displayedCurrency: string = 'USD';
  selectedUnit: UomOption = 'Imperial';
  currencyOptions: CurrencyDefinition[] = [];
  filteredCurrencies: CurrencyDefinition[] = [];
  currencySearchTerm: string = '';
  showCurrencyDropdown: boolean = false;
  showUomDropdown: boolean = false;
  isCurrencyLoading: boolean = false;
  showUoMSelection: boolean = true;
  currentRoutePath: string | undefined = undefined;
  hideHeaderActions: boolean = false;
  pageHeader: string = '';

  @ViewChild('currencyDropdown') currencyDropdownRef!: ElementRef;
  @ViewChild('uomDropdown') uomDropdownRef!: ElementRef;

  constructor(
    private _filterService: FiltersService,
    private filterOptionService: FilterOptionService,
    private _route: ActivatedRoute,
    private _router: Router,
    @Inject(FEATURE_FLAGS) private _featureFlags: FeatureFlags,
    private presentationService: PresentationService,
    private alertService: AlertService,
    private authenticationService: AuthenticationService,
    private authorizationService: AuthorizationService,
    private serviceInsightsService: ServiceInsightsService,
    private _brandingService: BrandingService,
    private userService: UserService,
    private currencyUomService: CurrencyUomService,
    private mixpanelService: MixpanelService) {
  }

  get userFullName(): string {
    const firstName = this.userService.getFirstName() || '';
    const lastName = this.userService.getLastName() || '';
    return `${firstName} ${lastName}`.trim() || 'User';
  }

  get title() {
    return this._brandingService.pageTitle;
  }

  get showLogoutButton() {
    return this._brandingService.isProgramHub;
  }

  get Role() {
    return Role;
  }

  get canImpersonate() {
    if (this.authenticationService.isImpersonating)
    {
      return true;
    }

    return this.authorizationService.hasPermission(Permission.Impersonate);
  }

  hasRole(role: Role) {
    return this.authorizationService.hasRole(role);
  }

  get isCurrencyAndUoMConversionFlagEnabled() {
    return this._featureFlags.enableCurrencyAndUoMConversion;
  }

  get uomOptions(): UomOption[] {
    return this.currencyUomService.uomOptions;
  }

  ngOnInit() {
      this._router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {
      let currentRoute = this._router.routerState.root;

      while (currentRoute.firstChild) {
        currentRoute = currentRoute.firstChild;
      }

      this.pageHeader = currentRoute.snapshot.data['PageName'] ?? '';
      this.hideHeaderActions = currentRoute.snapshot.data['hideHeaderActions'] === true;
      this.currentRoutePath = currentRoute.snapshot.routeConfig?.path;
    });

    this.filtersSubscription = this._filterService.selectedFiltersObservable.subscribe((f) => this.filters = f);

    this.filterOptionService.filterViewOptions.subscribe((options: FilterOption[] | undefined) => this.filterOptions = options );
    this._route.queryParams.subscribe(p => {
      if(p['site']) {
        this.pageName = p['site'];
      } else if (p['productName']){
        this.pageName = p['productName'];
      } else if (p['solutionGroup']){
        this.pageName = p['solutionGroup'];
      }else {
        this.pageName = '';
      }
    });

    this.currencySubscription = this.currencyUomService.selectedCurrency$.subscribe(currency => {
      this.selectedCurrency = currency;
      // Only update displayed currency if not loading (initial load or non-TVD pages)
      if (!this.isCurrencyLoading) {
        this.displayedCurrency = currency;
      }
    });
    this.uomSubscription = this.currencyUomService.selectedUom$.subscribe(uom => this.selectedUnit = uom);
    this.currencyOptionsSubscription = this.currencyUomService.currencyOptions$.subscribe(options => {
      this.currencyOptions = options;
      this.filteredCurrencies = options;
    });
    this.currencyLoadingSubscription = this.currencyUomService.isCurrencyLoading$.subscribe(loading => {
      this.isCurrencyLoading = loading;
      // When loading finishes, sync the displayed currency with selected currency
      if (!loading) {
        this.displayedCurrency = this.selectedCurrency;
      }
    });

    this.showUoMSelection = this.shouldShowUoMSelection();
    this.currencyUomService.loadCurrencies();
  }

  ngOnDestroy(): void {
    this.filtersSubscription?.unsubscribe();
    this.rolesSubscription?.unsubscribe();
    this.currencySubscription?.unsubscribe();
    this.uomSubscription?.unsubscribe();
    this.currencyOptionsSubscription?.unsubscribe();
    this.currencyLoadingSubscription?.unsubscribe();
  }

  onCurrencyChange(currency: string): void {
    this.currencyUomService.setCurrency(currency);
    this.mixpanelService.track('Currency Changed', { 'Currency': currency });
    this.showCurrencyDropdown = false;
    this.currencySearchTerm = '';
    this.filteredCurrencies = this.currencyOptions;
  }

  onUomChange(uom: UomOption): void {
    this.currencyUomService.setUom(uom);
    this.mixpanelService.track('UoM Changed', { 'UoM': uom });
  }

  onUomSelect(uom: UomOption): void {
    this.onUomChange(uom);
    this.showUomDropdown = false;
  }

  toggleUomDropdown(): void {
    this.showUomDropdown = !this.showUomDropdown;
  }

  onCurrencySearch(searchTerm: string): void {
    this.currencySearchTerm = searchTerm;
    this.filteredCurrencies = this.currencyUomService.searchCurrencies(searchTerm);
  }

  toggleCurrencyDropdown(): void {
    this.showCurrencyDropdown = !this.showCurrencyDropdown;
    if (!this.showCurrencyDropdown) {
      this.currencySearchTerm = '';
      this.filteredCurrencies = this.currencyOptions;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (this.currencyDropdownRef && !this.currencyDropdownRef.nativeElement.contains(event.target)) {
      this.showCurrencyDropdown = false;
      this.currencySearchTerm = '';
      this.filteredCurrencies = this.currencyOptions;
    }
    if (this.uomDropdownRef && !this.uomDropdownRef.nativeElement.contains(event.target)) {
      this.showUomDropdown = false;
    }
  }

  getSelectedCurrencyDisplay(): string {
    const currency = this.currencyOptions.find(c => c.currencyCodeId === this.displayedCurrency);
    return currency ? `${currency.symbol} ${currency.currencyCodeId}` : this.displayedCurrency;
  }

  private shouldShowUoMSelection(): boolean {
    return this.filters?.division !== 'Pest'; // Hide UoM selection for Pest division
  }

  ngDoCheck(): void {
    this.updateHeaderTexts();
    this.updateDownloadVisibility();
    this.displaySecondLevel = true;
    // save the selected data view value
    this.selectedDataView = this._filterService.selectedDataView;
    this.showUoMSelection = this.shouldShowUoMSelection();
  }

  allowPrefill() {
    if(this._filterService.selectedDataView == 'Contract') {
      sessionStorage.getItem('prefillAll' + this._filterService.selectedDataView);
    } else if (this._filterService.selectedDivision == 'QSR') {
      sessionStorage.getItem('prefillAll' + this._filterService.selectedDivision);
    }

      //  get the date range option
      const dateRangeOption = this.filterOptions?.find(option => option.id === 'dateRange');

      // Check if the option is found and has a 'selected' property
      if (dateRangeOption && 'selected' in dateRangeOption) {
        dateRangeOption.selected = [];

        // call setFilterViewOptions with the updated filter options so as to clear the persisted date
        this.filterOptionService.setFilterViewOptions(this.filterOptions);
      }
    this.serviceInsightsService.resetAddedServiceMetrics();
  }

  updateDownloadVisibility() {
    this.hidePresentationDownload = this.hideHeaderActions;
  }

  updateHeaderTexts() {
    const h5h7Divisions = ['QSR', 'FRS'];
    if(h5h7Divisions.includes(this._filterService.selectedDivision) || this._filterService.selectedDataView == "Contract") {
      this.topLevelText="H5s:";
      this.secondLevelText="H7s:";
      this.HeaderText="H5s/H7s";
    }
    else if(this._filterService.selectedDivision == "Distributor") {
      this.topLevelText="Partner Groups:";
      this.secondLevelText="Distributor Groups";
      this.HeaderText="Partner Groups/Distributor Groups";
    }
    else if(this._filterService.selectedDivision == "Pest"){
      this.topLevelText="Enterprise Names:";
      this.secondLevelText="Corporate Reference Names:";
      this.HeaderText="Enterprise Names/Corporate Reference Names";
    }
  }

  displayIfExistsElseDefault(value:string[]|string|undefined, level: string) {
    if (this.filters?.division == this._filterService.selectedDivision && this.filters?.dataView == this._filterService.selectedDataView){
      const h5h7Divisions = ["QSR", "FRS", "Pest"];
      if ((this.filters.division == "Institutional" && this.filters.dataView == "Contract") || h5h7Divisions.includes(this.filters.division)) {
        return level == 'topLevel' ? this.getDisplayH5ForContract() : this.getDisplayH7ForContract();
      }
      else if (this.filters.division == "Distributor") {
        let filterOptionsForDist: FilterOption[] | undefined = [];
        this.filterOptionService.filterViewOptions.subscribe(
          (filterOptions) => filterOptionsForDist = filterOptions
        );

        if (filterOptionsForDist != undefined) {
          value = level == 'topLevel' ? filterOptionsForDist[DistributorFilterModel.TopLevelContractGroup].selected : filterOptionsForDist[DistributorFilterModel.SecondLevelContractFilter].selected;
        }
      }

      if (value != undefined && value.length > 0) {
        let texToDisplay = "";
      for (let i=0; i<value.length; i++)
        {
          let line = "";
          line += `( ${value[i]} )`;
          if(i != value.length-1){
            line += ", ";
          }
          texToDisplay += line;
        }
      return texToDisplay;
      }
    }
    return "Make a selection.";
  }

  getDisplayH5ForContract() {
    let filtersForContract: Filters = new Filters();
    this._filterService.filtersConfirmed.subscribe(f => filtersForContract = f);
    let texToDisplay = "";

    if (filtersForContract != undefined && filtersForContract.topLevelHierarchies) {
      //Format each h5 for viewing
      for(let i=0; i<filtersForContract.topLevelHierarchies.length; i++)
        {
          let line = "";
          line += "(" + filtersForContract.topLevelHierarchies[i].h5Number + "): " + filtersForContract.topLevelHierarchies[i].name;
          // Pest has additional '-' before names, remove it
          if(this._filterService.selectedDivision == 'Pest') {
            line = line.replace('-', '');
          }
          if(i != filtersForContract.topLevelHierarchies.length-1){
            line += ", ";
          }

          //Add to h5s indicator
          texToDisplay += line;
        }
      return texToDisplay;
    } else {
      return "Make a selection.";
    }
  }

  getDisplayH7ForContract() {
    let filtersForContract: Filters = new Filters();
    this._filterService.filtersConfirmed.subscribe(f => filtersForContract = f);
    let texToDisplay = "";

    if (filtersForContract != undefined && filtersForContract.h7Agreements) {
      //Format each h7s for viewing
      for(let i=0; i<filtersForContract.h7Agreements.length; i++)
        {
          let line = "";
          line += "(" + filtersForContract.h7Agreements[i].number + "): " + filtersForContract.h7Agreements[i].name;
          // Pest has additional '-' before names, remove it
          if(this._filterService.selectedDivision == 'Pest') {
            line = line.replace('-', '');
          }
          if(i != filtersForContract.h7Agreements.length-1){
            line += ", ";
          }

          //Add to h7s indicator
          texToDisplay += line;
        }
      return texToDisplay;
    } else {
      return "Make a selection.";
    }
  }



  createPresentationErrorAlert(): Alert {
    const id = Math.random() * 25;
    const message =
      'The presentation download has encountered an error. Please try again. If another error occurs, you may need to apply more filters to the data.';
    return { id: id, message: message };
  }

  executeBrowserDownload(fileData: BlobPart) {
    const url = window.URL.createObjectURL(new Blob([fileData]));

    const link = document.createElement('a');
    link.href = encodeURI(url);
    link.setAttribute('download', 'EBR-data-' + new Date() + '.pptx');

    document.body.appendChild(link);
    link.click();
  }

  protected readonly sessionStorage = sessionStorage;

  logout() {
    this.authenticationService.logout();
  }
}
